// ======================
// ACTION TYPES

import { axiosGetV3 } from '../utils/AxiosApi';
import { URL } from '../utils/Constants';
import { generalSize } from '../utils/ValidRateUtils';

// ======================
const FETCH_CONTAINER_SIZES_START = 'containerSizes/FETCH_START';
const FETCH_CONTAINER_SIZES_SUCCESS = 'containerSizes/FETCH_SUCCESS';
const FETCH_CONTAINER_SIZES_FAILURE = 'containerSizes/FETCH_FAILURE';

// ======================
// INITIAL STATE
// ======================
const initialState = {
  rawSizes: [], // Original API data
  groupedOptions: [], // Formatted for dropdowns
  loading: false,
  error: null
};

// ======================
// ACTION CREATORS
// ======================
const fetchStart = () => ({ type: FETCH_CONTAINER_SIZES_START });
const fetchSuccess = (data) => ({
  type: FETCH_CONTAINER_SIZES_SUCCESS,
  payload: data
});
const fetchFailure = (error) => ({
  type: FETCH_CONTAINER_SIZES_FAILURE,
  payload: error
});

// ======================
// THUNK ACTION
// ======================
export const fetchContainerSizes = () => (dispatch) => {
  dispatch(fetchStart());

  axiosGetV3(URL.containerSizeCategoriesUrl)
    .then((response) => {
      if (response.data.success) {
        const containerSizes = response.data?.data?.items || [];

        // Transform data
        const getOptions = (categoryName) => {
          return (
            containerSizes
              .find((item) => item.name === categoryName)
              ?.containerSizes?.map((size) => ({
                label: size.size,
                value: size.size,
                id: size.id
              })) || []
          );
        };

        dispatch(
          fetchSuccess({
            rawSizes: containerSizes,
            groupedOptions: [
              { label: 'General Sized', options: generalSize },
              { label: 'Regular Sized', options: getOptions('Regular Sized') },
              { label: 'Reefer Equipment', options: getOptions('Reefer Equipment') },
              { label: 'In-Gauge', options: getOptions('In-Gauge') },
              { label: 'Out-Gauge', options: getOptions('Out-Gauge') }
            ]
          })
        );
      }
    })
    .catch((error) => {
      console.log(error, 'Dispatch error');
      dispatch(fetchFailure(error.message));
    });
};

// ======================
// REDUCER
// ======================
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CONTAINER_SIZES_START:
      return { ...state, loading: true, error: null };

    case FETCH_CONTAINER_SIZES_SUCCESS:
      return {
        ...state,
        loading: false,
        rawSizes: action.payload.rawSizes,
        groupedOptions: action.payload.groupedOptions
      };

    case FETCH_CONTAINER_SIZES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}

// ======================
// SELECTORS
// ======================
export const selectRawSizes = (state) => state.containerSizes.rawSizes;
export const selectGroupedOptions = (state) => state.containerSizes.groupedOptions;
export const selectLoading = (state) => state.containerSizes.loading;
export const selectError = (state) => state.containerSizes.error;
